<app-full-panel-modal [isOpen]="isModalOpen()" (closeModal)="onClose()">
  <router-outlet name="modal"></router-outlet>
</app-full-panel-modal>
